module.exports = __webpack_public_path__ + "img/dash-card-received.b5b6095b.svg";